/** Predefined frontpage tiles for the add-card picker. */

export const FRONTPAGE_PRESETS = [
  {
    id: 'stat-items',
    titleKey: 'ui.presetItems',
    hintKey: 'ui.presetItemsHint',
    icon: 'cube',
    color: 'sky',
    card: {
      title: 'Items',
      section: 'Overview',
      content_type: 'statistics',
      data: 'item',
      link: '/items',
      icon: 'cube',
      color: 'sky',
      col_span: 1,
      order: 10,
    },
  },
  {
    id: 'stat-inventory',
    titleKey: 'ui.presetInventory',
    hintKey: 'ui.presetInventoryHint',
    icon: 'archive',
    color: 'teal',
    card: {
      title: 'Inventory records',
      section: 'Overview',
      content_type: 'statistics',
      data: 'item_metadata',
      link: '/items',
      icon: 'archive',
      color: 'teal',
      col_span: 1,
      order: 11,
    },
  },
  {
    id: 'stat-projects',
    titleKey: 'ui.presetProjects',
    hintKey: 'ui.presetProjectsHint',
    icon: 'clipboard',
    color: 'violet',
    card: {
      title: 'Projects',
      section: 'Overview',
      content_type: 'statistics',
      data: 'project',
      link: '/projects',
      icon: 'clipboard',
      color: 'violet',
      col_span: 1,
      order: 12,
    },
  },
  {
    id: 'stat-customers',
    titleKey: 'ui.presetCustomers',
    hintKey: 'ui.presetCustomersHint',
    icon: 'account-group',
    color: 'rose',
    card: {
      title: 'Customers',
      section: 'Overview',
      content_type: 'statistics',
      data: 'customer',
      link: '/customers',
      icon: 'account-group',
      color: 'rose',
      col_span: 1,
      order: 13,
    },
  },
  {
    id: 'link-warehouse',
    titleKey: 'ui.presetWarehouse',
    hintKey: 'ui.presetWarehouseHint',
    icon: 'warehouse',
    color: 'green',
    card: {
      title: 'Warehouse',
      section: 'Browse',
      content_type: 'link',
      link: '/warehouse',
      icon: 'warehouse',
      color: 'green',
      col_span: 1,
      order: 20,
    },
  },
  {
    id: 'link-categories',
    titleKey: 'ui.presetCategories',
    hintKey: 'ui.presetCategoriesHint',
    icon: 'tag',
    color: 'orange',
    card: {
      title: 'Categories',
      section: 'Browse',
      content_type: 'link',
      link: '/categories',
      icon: 'tag',
      color: 'orange',
      col_span: 1,
      order: 21,
    },
  },
  {
    id: 'link-projects',
    titleKey: 'ui.presetAllProjects',
    hintKey: 'ui.presetAllProjectsHint',
    icon: 'folder',
    color: 'indigo',
    card: {
      title: 'All Projects',
      section: 'Browse',
      content_type: 'link',
      link: '/projects',
      icon: 'folder',
      color: 'indigo',
      col_span: 2,
      order: 22,
    },
  },
  {
    id: 'link-pick',
    titleKey: 'ui.presetPickItems',
    hintKey: 'ui.presetPickItemsHint',
    icon: 'barcode',
    color: 'amber',
    card: {
      title: 'Pick items',
      section: 'Quick actions',
      content_type: 'link',
      link: '/projects?mode=pick',
      icon: 'barcode',
      color: 'amber',
      col_span: 1,
      order: 1,
    },
  },
  {
    id: 'link-return',
    titleKey: 'ui.presetReturnItems',
    hintKey: 'ui.presetReturnItemsHint',
    icon: 'swap',
    color: 'blue',
    card: {
      title: 'Return items',
      section: 'Quick actions',
      content_type: 'link',
      link: '/return',
      icon: 'swap',
      color: 'blue',
      col_span: 1,
      order: 2,
    },
  },
  {
    id: 'chart-readiness',
    titleKey: 'ui.equipmentReadiness',
    hintKey: 'ui.presetReadinessHint',
    icon: 'chart',
    color: 'emerald',
    card: {
      title: 'Equipment readiness',
      section: 'Overview',
      content_type: 'chart',
      data: 'readiness',
      link: '/items',
      icon: 'chart',
      color: 'emerald',
      col_span: 2,
      order: 30,
    },
  },
  {
    id: 'chart-workload',
    titleKey: 'ui.upcomingWorkload',
    hintKey: 'ui.presetWorkloadHint',
    icon: 'calendar',
    color: 'indigo',
    card: {
      title: 'Upcoming workload',
      section: 'Overview',
      content_type: 'chart',
      data: 'workload',
      link: '/projects',
      icon: 'calendar',
      color: 'indigo',
      col_span: 2,
      order: 31,
    },
  },
]
